export const debounce = (func, waitFor = 200) => {
    let timeout;

    return {
        debounceFunc: (...args) => {
            if(timeout) {
                clearTimeout(timeout);
            }

            timeout = window.setTimeout(() => {
                func(...args);
            }, waitFor)
        },
        cancel: () => {
            if(timeout) {
                clearTimeout(timeout)
            }
        }
    }
}
